export default __webpack_public_path__ + "static/media/icon-verydissatisfied.9796ac3b.svg";